import { useMemo, useState } from 'react';

import { appUiIds } from '@/constants/appUiIds';

import useAppUiData from '@/hooks/useAppUiData';

import styles from './ClaimBookingStep.module.scss';
import ClaimBookingSuccessLayout from './ClaimBookingSuccessLayout';
import ClaimBookingRadioGroup from './controls/ClaimBookingRadioGroup';
import { getCurrentClaimedSailor } from '../helpers/claimBookingHelper';
import { MatchingClient, StepData } from '../types/ClaimBookingTypes';

const CURRENT_USER_ID = 'current';

type ClaimBookingEmailSelectOTPProps = {
  tabId: string;
  data: StepData;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (selectedEmail: string, selectedClientId: string) => void;
  onCancel: () => void;
  sessionUserEmail?: string;
};

const ClaimBookingEmailSelectOTP = ({
  tabId,
  data,
  sessionUserEmail,
  onSubmit,
  onCancel,
}: ClaimBookingEmailSelectOTPProps) => {
  const appUiData = useAppUiData();
  // Get the currently claimed sailor from the data
  const matchedSailor = getCurrentClaimedSailor(data) as MatchingClient;

  const STEP_CONFIG = {
    title: appUiData[appUiIds.claimBooking.otpSuccessTitle],
    subtitle: appUiData[appUiIds.claimBooking.emailOrDobSelectOtpSubtitle],
    description: appUiData[appUiIds.claimBooking.emailSelectOtpDescription],
  } as const;

  const sailors = useMemo(
    () => [{ clientId: CURRENT_USER_ID, email: sessionUserEmail }, matchedSailor],
    [matchedSailor, sessionUserEmail],
  );

  const [selectedSailor, setSelectedSailor] = useState<MatchingClient>(sailors[0]);

  const handleChange = (value: MatchingClient) => {
    setSelectedSailor(value);
  };

  const handleSubmit = () => {
    const selectedEmail = selectedSailor.email || sessionUserEmail || '';
    const selectedClientId = selectedSailor.clientId || CURRENT_USER_ID;

    onSubmit(selectedEmail, selectedClientId);
  };

  return (
    <ClaimBookingSuccessLayout
      tabId={tabId}
      messages={STEP_CONFIG}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isSubmitDisabled={false}
    >
      <div className={styles.radioGroup}>
        <ClaimBookingRadioGroup
          sailors={sailors}
          selectedSailor={selectedSailor}
          onChange={handleChange}
          labelFunction={(sailor) => sailor.email || ''}
        />
      </div>
    </ClaimBookingSuccessLayout>
  );
};

export default ClaimBookingEmailSelectOTP;
